<template>
  <nav id="main-navbar"
       class="sticky-top navbar navbar-expand-lg bg-body-tertiary "
       style="background-color: white!important;">
    <div class="container-fluid" id="navbar" style="margin: 0 auto; max-width: 1200px;">
      <a class="navbar-brand m-0 p-0" @click="goToMain">
        <img src="@/assets/logo_3.svg"
             style="height: 48px;color: white" alt="logo" id="logo">
      </a>
      <button class="navbar-toggler" type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <a class="nav-link text-black me-0 me-lg-3" @click="goToHome"
             style="font-family: uber-move-text, sans-serif; font-weight: 500">Inici</a>
<!--          <a class="nav-link text-black me-0 me-lg-3" @click="goToDairy"
             style="font-family: uber-move-text, sans-serif; font-weight: 500">Menú</a>-->
          <a class="nav-link text-black me-0 me-lg-3" @click="goToMenu"
             style="font-family: uber-move-text, sans-serif; font-weight: 500">Carta</a>
          <!--          <a class="nav-link text-black me-0 me-lg-3" @click="goToAbout"
                       style="font-family: uber-move-text, sans-serif; font-weight: 500">Nosaltres</a>-->
          <a class="nav-link text-black me-0 me-lg-3" @click="goToBook"
             style="font-family: uber-move-text, sans-serif; font-weight: 500">Reservar</a>
        </ul>
      </div>
    </div>
  </nav>
  <!--  <nav id="main-navbar" class="sticky-top navbar navbar-expand-sm bg-body-tertiary navbar-light px-3 py-0"
         style="background-color: white">
      &lt;!&ndash;       :style="router.currentRoute.value.name==='menu-detail'||router.currentRoute.value.name==='item-detail'?'background-color: white': 'background-color:lightgoldenrodyellow'">&ndash;&gt;

      <div class="container-fluid px-0" id="navbar"
           style="margin: 0 auto; max-width: 1200px;">
        <div class="py-2" style="">
          <a class="navbar-brand m-0 p-0" @click="goToMenu">
            <img src="@/assets/logo_3.svg"
                 style="height: 48px;color: white" alt="logo" id="logo">
          </a>

          &lt;!&ndash;
                  <a class="navbar-brand m-0 p-0 fw-bold " @click="goToMenu"
                     id="nav-text"
                     style="line-height: 48px; color: #12b3b2; margin-left: 0.5rem!important;">
                    <a style="color: #000; font-family: Smooch, sans-serif">Cuina de</a>
                    la iaia
                    <a style="color: #000; font-family: Smooch, sans-serif">Badalona</a>
                  </a>
          &ndash;&gt;

          <button class="navbar-toggler" type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <div class="navbar-nav">
              <a class="nav-link text-black" @click="goToHome"
                 style="font-family: uber-move-text, sans-serif; font-weight: 500">Inici</a>
              <a class="nav-link text-black" @click="goToMenu"
                 style="font-family: uber-move-text, sans-serif; font-weight: 500">Carta</a>
              &lt;!&ndash;            <a class="nav-link text-black" @click="goToContact"
                             style="font-family: uber-move-text, sans-serif; font-weight: 500">Contacte</a>&ndash;&gt;
              <a class="nav-link text-black" @click="goToAbout"
                 style="font-family: uber-move-text, sans-serif; font-weight: 500">Nosaltres</a>
              <a class="nav-link text-black" @click="goToBook"
                 style="font-family: uber-move-text, sans-serif; font-weight: 500">Reservar</a>
            </div>
          </div>
        </div>


      </div>


    </nav>-->


</template>

<script>
import {useRouter} from "vue-router"
import {useStore} from "vuex";
import {computed} from "vue";

export default {
  name: "NavBar",
  setup() {
    const router = useRouter()
    const store = useStore()
    const cart = computed(() => store.getters['cartModule/getItems']())

    window.onscroll = function () {
      scrollFunction()
    };

    function scrollFunction() {
      if (document.body.scrollTop > 71 || document.documentElement.scrollTop > 71) {
        document.getElementById("navbar").style.justifyContent = "space-between";
        document.getElementById("logo").style.display = "inline";
        //document.getElementById("main-navbar").style.borderBottom = "0";
        //document.getElementById("main-navbar").style.padding = "8px 0";
        document.getElementById("main-navbar").style.boxShadow = "0px 5px 30px -15px rgba(0,0,0,0.75)";
        //document.getElementById("nav-text").style.fontSize = "1.25rem";

      } else {
        document.getElementById("navbar").style.justifyContent = "space-between";
        document.getElementById("logo").style.display = "inline";
        //document.getElementById("main-navbar").style.borderBottom = "1px solid";
        //document.getElementById("main-navbar").style.padding = "8px 0";
        document.getElementById("main-navbar").style.boxShadow = "none";
        //document.getElementById("nav-text").style.fontSize = "1.25rem";

      }
    }

    const changeCollapse = () => {
      let a = document.getElementById("navbarNav")


      if (a.classList.contains('show')) {
        a.classList.remove("show")

      } else {
        a.classList.add("show")

      }
    }

    return {
      cart,
      router,
      total_items: computed(() => {
        if (cart.value.length === 0) return 0
        else {
          return cart.value.map((a) => a.quantity).reduce((prev, next) => prev + next)
        }
      }),
      changeCollapse,
      goToMain: () => {
        router.push({name: 'home'})
      },
      goToHome: () => {
        changeCollapse()
        router.push({name: 'home'})
      },
      goToMenu: () => {
        changeCollapse()
        router.push({name: 'menu-detail'})
      },
      goToContact: () => {
        router.push({name: 'contact'})
      },
      goToDairy: () => {
        changeCollapse()
        router.push({name: 'dairy'})
      },
      goToBook: () => {
        changeCollapse()
        router.push({name: 'book'})
      },

      isGrayBackground: computed(() => {
        return router.currentRoute.value.name === 'cart'
      }),


    }
  }
}
</script>

<style lang="scss" scoped>
@import url("../../../assets/animate.min.css");

.nav-hover :hover {
  background-color: #8BD3E6;
}

#nav {
  padding: 30px;
  text-align: center;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

.display-none {
  display: none !important;
}

@media (min-width: 768px) {
  .md-display {
    display: flex;
  }
  .md-fs-4 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }


}

@media (max-width: 576px) {
  .sm-none {
    display: none;
  }

}

.navbar-toggler,
.navbar-toggler:focus,
.navbar-toggler:active,
.navbar-toggler-icon:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .md-none {
    display: none;
  }
  .md-mr-1 {
    margin-right: 0.25rem
  }


}

@media (max-width: 992px) {
  .lg-none {
    display: none;
  }
  .custom-nav-px {
    padding: 0 1rem !important;
  }
  .custom-nav-mx {
    margin: 0 1rem !important;
  }
}

@media (min-width: 991px) {
  .custom-nav-px {
    padding: 0 8rem !important;
  }
  .custom-nav-mx {
    margin: 0 8rem !important;
  }
}

.btm-shadow {
  box-shadow: 0 5px 5px rgba(182, 182, 182, 0.75);
}

.navbar-nav a {
  margin-right: 1.5rem;
}

.navbar-nav a:last-child {
  margin-right: 0;
}


</style>
